import { useConfirmationPage } from "@/contexts/confirmPage";
import { useState } from "react";
import { CA_EVENT_TYPES } from "@/types/classifiedAnalytics";
import { sendClassifiedAnalytics } from "@/api/sendClassifiedAnalytics";
import { useBrandUrl } from "@/hooks";
import { CLASSIFIED_ANALYTICS_PATH } from "@/constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const useSimilarListingsClassifiedAnalyticsTracking = () => {
    const { showConfirm } = useConfirmationPage();
    const isPreviewMode = useIsPreviewMode();
    const analyticsUrl = useBrandUrl({ endpoint: CLASSIFIED_ANALYTICS_PATH });
    const [sentClassifieds, setSentClassifieds] = useState([]);
    const eventType = showConfirm
        ? CA_EVENT_TYPES.RECOMMENDED_CARD_VIEW_CONFIRMATION
        : CA_EVENT_TYPES.RECOMMENDED_CARD_VIEW;
    const sendSimilarListingsAnalytics = (classifiedIds) => {
        const newClassifieds = classifiedIds.filter((id) => !sentClassifieds.includes(id));
        if (isPreviewMode || newClassifieds.length === 0) {
            return;
        }
        setSentClassifieds([...sentClassifieds, ...newClassifieds]);
        const eventData = {
            type: eventType,
            data: { classifiedIds: newClassifieds },
        };
        sendClassifiedAnalytics(analyticsUrl, eventData);
    };
    return {
        sendSimilarListingsAnalytics,
    };
};
